import { IBayLevelData } from "open-vessel-definition";

export function hasZeroRow(bl: IBayLevelData): boolean {
  if (bl.perSlotInfo) {
    return Object.keys(bl.perSlotInfo).some((slot) => slot.indexOf("00") === 0);
  }

  return false;
}
